import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

import Loader from '@/components/Loader/index.vue'
import PincodeInput from 'vue-pincode-input';

import api from '@/helpers/fetch'
import store from '@/store/store.js'

library.add(faPlusCircle)

@Component({
	components: {
		Loader,
		PincodeInput,
	},
})
export default class PasswordRecovery extends Vue {
	form = {
		email: '',
		code: '',
		password: '',
		passwordRepeat: '',
	};

	sendMailLoading = false;
	sendCodeLoading = false;
	sendPasswordLoading = false;
	countingDown = false;
	errorMsg = '';
	tabIndex = 0;
	currentInterval = 0;
	timeLeft = '';


	async sendMail() {
		if (!this.form.email) return;

		this.errorMsg = '';
		this.sendMailLoading = true;
		const res = await api.post('/api/login/password/recovery', { email: this.form.email });
		this.sendMailLoading = false;
		if (res.ok) {
			this.errorMsg = '';
			this.startTimer();
			this.tabIndex = 1;
			// @ts-ignore
			this.$nextTick(this.$refs.pincode.focusCellByIndex);
		} else {
			if (res.cod === 1) {
				// db error
				this.errorMsg = res.msg;
			} else if (res.cod === 2) {
				this.errorMsg = 'Usuário não encontrado';
			} else if (res.cod === 3) {
				this.errorMsg = 'Colaboradores não podem ter senha, volte a tela de login e clique em "Acesso de Colaborador"';
			} else {
				// erro desconhecido
				this.errorMsg = res.msg;
			}
		}
	}

	async sendCode() {
		if (!this.form.code) return;

		this.errorMsg = '';
		this.sendCodeLoading = true;
		const res = await api.post('/api/login/password/code', { email: this.form.email, code: this.form.code });
		this.sendCodeLoading = false;
		if (res.ok) {
			this.errorMsg = '';
			this.clearTimer();
			this.tabIndex = 2;
		} else {
			if (res.cod === 1) {
				// db error
				this.errorMsg = res.msg;
			} else if (res.cod === 2) {
				this.errorMsg = 'Usuário não encontrado';
			} else if (res.cod === 3) {
				this.errorMsg = 'Colaboradores não podem ter senha, volte a tela de login e clique em "Acesso de Colaborador"';
			} else if (res.cod === 4) {
				this.errorMsg = 'Código Expirado';
			} else if (res.cod === 5) {
				this.errorMsg = 'Código Inválido';
			} else {
				this.errorMsg = 'Erro desconhecido, entre em contato com suporte';
			}
		}
	}

	async sendPassword() {
		if (this.form.password === '') {
			this.errorMsg = 'Por favor, preencha uma senha';
			return;
		}

		if (this.form.password.length < 5 || this.form.password.length > 16) return;


		if (this.form.password !== this.form.passwordRepeat) {
			this.errorMsg = 'As senhas não coincidem';
			return;
		}

		this.errorMsg = '';
		this.sendPasswordLoading = true;
		const res = await api.post('/api/login/password/reset', { email: this.form.email, code: this.form.code, password: this.form.password });
		this.sendPasswordLoading = false;

		if (res.ok) {
			this.$bvToast.toast('Redirecionando para login...', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center'
			});

			setTimeout(() => { this.$router.push('/login'); }, 2000);
		} else {
			if (res.cod === 1) {
				// db error
				this.errorMsg = res.msg;
			} else if (res.cod === 2) {
				this.errorMsg = 'Usuário não encontrado';
			} else if (res.cod === 3) {
				this.errorMsg = 'Colaboradores não podem ter senha, volte a tela de login e clique em "Acesso de Colaborador"';
			} else if (res.cod === 4) {
				this.errorMsg = 'Código Expirado';
			} else if (res.cod === 5) {
				this.errorMsg = 'Código Inválido';
			} else if (res.cod === 6) {
				// db error
				this.errorMsg = res.msg;
			} else {
				this.errorMsg = 'Erro desconhecido, entre em contato com suporte';
			}
		}
	}

	get passwordHasError() {
		return (this.form.password.length < 5 || this.form.password.length > 16);
	}

	clearTimer() {
		this.timeLeft = '';
		clearInterval(this.currentInterval);
	}

	updateTimeLeft(timer) {
		let minutes: string | number = Math.trunc(timer / 60);
		let seconds: string | number = timer % 60;

		minutes = minutes < 10 ? "0" + minutes : minutes;
		seconds = seconds < 10 ? "0" + seconds : seconds;

		this.timeLeft = minutes + ":" + seconds;
	}

	startTimer() {
		let timer = 90; // timer em segundos
		this.updateTimeLeft(timer);

		this.countingDown = true;
		this.currentInterval = setInterval(() => {
			this.updateTimeLeft(timer);

			if (--timer < 0) {
				this.countingDown = false;
				this.clearTimer();
			}
		}, 1000) as any;
	}

}
